import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=5f6fda9a&scoped=true&"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./UserSubscriptions.vue?vue&type=style&index=0&id=5f6fda9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fda9a",
  null
  
)

export default component.exports